module.exports = __webpack_public_path__ + "media/images/brands/marque-essie-fcdea186ef343ace45d95c9c0f4201bd.jpg";